<template>
  <div class="quiz-container">
    <h2>Chestionar despre piața de artă</h2>

    <form @submit.prevent="submitQuiz">
      <div class="question" v-for="(question, qkey) in questions" :key="qkey">
        <h3>{{ question.label }}</h3>
        <div v-for="(option, index) in question.options" :key="index" class="option">
          <input
              type="checkbox"
              :id="`${qkey}_${index}`"
              :key="`${qkey}_${index}_${answers[qkey]}`"
              :checked="answers[qkey] === option"
              @click.prevent="selectOption(qkey, option)"
          />
          <label :for="`${qkey}_${index}`">{{ option }}</label>
        </div>
      </div>

      <button type="submit" :disabled="!isComplete">Trimite răspunsurile</button>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    initialAnswers: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      answerKeyMap: {
        q1: 'gender',
        q2: 'age',
        q3: 'domain',
        q4: 'artworks_bought',
        q5: 'wealth_percent',
        q6: 'auctions_attended',
        q7: 'lot_types',
        q8: 'storage',
        q9: 'motivation',
        q10: 'trust'
      },
      answers: {
        q1: '', q2: '', q3: '', q4: '', q5: '',
        q6: '', q7: '', q8: '', q9: '', q10: ''
      },
      questions: {
        q1: {label: "1. Genul", options: ["Masculin", "Feminin", "Non-binar", "Prefer să nu aleg"]},
        q2: {label: "2. Vârsta", options: ["25-34", "35-44", "45-54", "55-64", "65-75", "Peste 75 de ani"]},
        q3: {
          label: "3. În ce domeniu activați?",
          options: ["Artă", "Finanțe", "Imobiliare", "Tech", "Media/Comunicare", "Legal", "Publicitate", "Divertisment", "Agricultură", "Consultanță", "Altele"]
        },
        q4: {
          label: "4. Câte lucrări de artă ați cumpărat în ultimul an?",
          options: ["1-5 lucrări", "6-24", "25-49", "Peste 50", "Nu doresc să răspund"]
        },
        q5: {
          label: "5. Ce procent din averea dumneavoastră totală estimați că este reprezentat de artă?",
          options: ["1-5 %", "6-10", "11-20", "21-30", "31-50", "Peste 50%", "Nu doresc să răspund"]
        },
        q6: {
          label: "6. La câte licitații ai participat în ultimul an?",
          options: ["1-10", "11-20", "21-30", "Peste 30"]
        },
        q7: {
          label: "7. Ce tip de loturi ați adjudecat preponderent în ultimul an?",
          options: ["Pictură", "Sculptură", "Artă decorativă", "Artă tradițională", "Carte", "Icoane", "Bijuterii", "Ceasuri", "Numismatică", "Militaria", "Artă istorică", "Sports & Music Memorabilia", "Altele"]
        },
        q8: {
          label: "8. Unde păstrați lucrarea de artă achiționată?",
          options: ["Acasă", "La birou", "Într-un depozit", "Într-o galerie de artă", "Am donat-o unui muzeu", "Prefer să nu răspund"]
        },
        q9: {
          label: "9. Care este motivația primară a achiziției de artă pentru dumneavoastră?",
          options: ["Estetică", "Emoțională", "Dorința de a clădi o colecție", "Randamentul investiției", "Status", "Mecenat", "Diversificarea portofoliului", "Altă motivație"]
        },
        q10: {label: "10. Aveți încredere în piața românească de artă?", options: ["Da", "Nu", "Prefer să nu răspund"]}
      }
    };
  },
  computed: {
    isComplete() {
      return Object.values(this.answers).every(a => a !== '');
    }
  },
  methods: {
    selectOption(qkey, option) {
      this.answers[qkey] = option;
    },
    async submitQuiz() {
      try {
        await axios.post('/api/quiz', {
          gender: this.answers.q1,
          age: this.answers.q2,
          domain: this.answers.q3,
          artworks_bought: this.answers.q4,
          wealth_percent: this.answers.q5,
          auctions_attended: this.answers.q6,
          lot_types: this.answers.q7,
          storage: this.answers.q8,
          motivation: this.answers.q9,
          trust: this.answers.q10
        });
        alert('Vă mulțumim pentru participare! Răspunsurile dvs. au fost înregistrate.');
        Object.keys(this.answers).forEach(key => {
          this.answers[key] = '';
        });
      } catch (error) {
        console.error('Eroare la trimiterea răspunsurilor:', error);
        alert('A apărut o eroare. Vă rugăm să încercați din nou.');
      }
    }
  },
  mounted() {
    if (this.initialAnswers) {
      Object.entries(this.answerKeyMap).forEach(([qKey, backendKey]) => {
        if (this.initialAnswers[backendKey] && this.initialAnswers[backendKey] !== null) {
          this.answers[qKey] = this.initialAnswers[backendKey];
        }
      });
    }
  }
};
</script>

<style scoped>
.quiz-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.question {
  margin-bottom: 30px;
  padding: 15px;
  background: #f8f8f8;
  border-radius: 8px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
}

h3 {
  margin-top: 0;
  margin-bottom: 15px;
}

.option {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

input[type="checkbox"] {
  margin-right: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

label {
  cursor: pointer;
  margin: 0 !important;
}

button {
  display: block;
  width: 100%;
  padding: 15px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #45a049;
}

button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}
</style>
